import { SimpleGrid } from '@chakra-ui/react'
import { ConnectedDatePicker, ConnectedSwitch, ConnectedTextArea } from 'components/FormElements'

import React from 'react'

const AdditionalInfo: React.FC<{ isTabletOrMobile: boolean }> = ({ isTabletOrMobile }) => {
  return (
    <>
      <ConnectedDatePicker
        name="Occupation_date"
        placeholder="e.g 01/05/2024"
        label="Occupation Date *"
      />
      <SimpleGrid rowGap={0} columnGap={2} columns={isTabletOrMobile ? 0 : 4}>
        <ConnectedSwitch name="Furnished" label="Furnished" />
        <ConnectedSwitch name="Pool" label="Pool" />
      </SimpleGrid>
      <ConnectedTextArea
        name="Description"
        placeholder="Description ..."
        label="Property Description *"
        py={8}
      />
    </>
  )
}

export default AdditionalInfo
